import React from "react";

interface FitHeightIconProps {
  className?: string;
}

const FitHeightIcon: React.FC<FitHeightIconProps> = ({
  className = "w-4 h-4",
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_2331_3572"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="20"
      height="20"
    >
      <rect x="2" y="2" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2331_3572)">
      <path
        d="M7.25646 19.9168C6.83549 19.9168 6.47917 19.771 6.1875 19.4793C5.89583 19.1877 5.75 18.8313 5.75 18.4104V5.58995C5.75 5.16898 5.89583 4.81266 6.1875 4.521C6.47917 4.22933 6.83549 4.0835 7.25646 4.0835H16.7435C17.1645 4.0835 17.5208 4.22933 17.8125 4.521C18.1042 4.81266 18.25 5.16898 18.25 5.58995V18.4104C18.25 18.8313 18.1042 19.1877 17.8125 19.4793C17.5208 19.771 17.1645 19.9168 16.7435 19.9168H7.25646ZM17 18.4104V5.58995C17 5.52579 16.9733 5.46704 16.9198 5.4137C16.8665 5.36023 16.8077 5.3335 16.7435 5.3335H7.25646C7.19229 5.3335 7.13354 5.36023 7.08021 5.4137C7.02674 5.46704 7 5.52579 7 5.58995V18.4104C7 18.4745 7.02674 18.5333 7.08021 18.5866C7.13354 18.6401 7.19229 18.6668 7.25646 18.6668H16.7435C16.8077 18.6668 16.8665 18.6401 16.9198 18.5866C16.9733 18.5333 17 18.4745 17 18.4104ZM9.69229 9.41996H14.3077L12 7.11245L9.69229 9.41996ZM12 16.8879L14.3077 14.5804H9.69229L12 16.8879Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default FitHeightIcon;
